/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageAttachmentResponseDto
 */
export interface MessageAttachmentResponseDto {
    /**
     * Attachment URL
     * @type {string}
     * @memberof MessageAttachmentResponseDto
     */
    url: string;
    /**
     * Attachment filename
     * @type {string}
     * @memberof MessageAttachmentResponseDto
     */
    filename: string;
    /**
     * Attachment MIME type
     * @type {string}
     * @memberof MessageAttachmentResponseDto
     */
    mimeType: string;
    /**
     * Attachment size in bytes
     * @type {number}
     * @memberof MessageAttachmentResponseDto
     */
    size?: number;
    /**
     * Attachment thumbnail URL
     * @type {string}
     * @memberof MessageAttachmentResponseDto
     */
    thumbnail?: string;
}

/**
 * Check if a given object implements the MessageAttachmentResponseDto interface.
 */
export function instanceOfMessageAttachmentResponseDto(value: object): value is MessageAttachmentResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined) return false;
    return true;
}

export function MessageAttachmentResponseDtoFromJSON(json: any): MessageAttachmentResponseDto {
    return MessageAttachmentResponseDtoFromJSONTyped(json, false);
}

export function MessageAttachmentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageAttachmentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'url': json['url'],
        'filename': json['filename'],
        'mimeType': json['mimeType'],
        'size': json['size'] == null ? undefined : json['size'],
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
    };
}

export function MessageAttachmentResponseDtoToJSON(json: any): MessageAttachmentResponseDto {
    return MessageAttachmentResponseDtoToJSONTyped(json, false);
}

export function MessageAttachmentResponseDtoToJSONTyped(value?: MessageAttachmentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['url'],
        'filename': value['filename'],
        'mimeType': value['mimeType'],
        'size': value['size'],
        'thumbnail': value['thumbnail'],
    };
}

